<template>
	<div
		id="guides-container"
		class="w-full flex flex-col items-center justify-center"
	>
		<GuidesHierarchySelect
			class="w-full md:w-4/12"
			:value="localModules"
			@config="OpenConfigModal"
		/>

		<GuideConfigModal
			v-if="showConfigModal"
			:type="selected.type"
			:item="selected.item"
			@close="showConfigModal = false"
		/>
	</div>
</template>

<script>
	import _ from 'lodash'
	import { mapActions, mapGetters } from 'vuex'
	import GuideConfigModal from './components/GuideConfigModal.vue'
	import GuidesHierarchySelect from './components/GuidesHierarchySelect.vue'

	export default {
		name: 'Guides',
		components: {
			GuideConfigModal,
			GuidesHierarchySelect,
		},
		props: {
			organization: {
				type: Object,
				required: true,
			},
		},
		data() {
			return {
				localModules: [],
				showConfigModal: false,
				selected: {
					type: null,
					item: null,
				},
				loadingModulesAndModalities: false,
			}
		},
		computed: {
			...mapGetters('system', ['modules', 'modalities']),
		},
		watch: {
			modules: {
				async handler(val) {
					if (!val.length) {
						await this.ModulesAndModalitiesHandler()
						return
					}
					this.StructGuidesHierarchy()
				},
				immediate: true,
			},
			modalities: {
				async handler(val) {
					if (!val.length) {
						await this.ModulesAndModalitiesHandler()
						return
					}
					this.StructGuidesHierarchy()
				},
				immediate: true,
			},
		},
		methods: {
			...mapActions('system', ['GetModulesAndModalities']),
			async ModulesAndModalitiesHandler() {
				return new Promise((res, rej) => {
					if (this.loadingModulesAndModalities) return res()
					this.loadingModulesAndModalities = true

					this.GetModulesAndModalities()
						.then(() => {
							res()
						})
						.finally(() => {
							this.loadingModulesAndModalities = false
						})
				})
			},
			StructGuidesHierarchy() {
				const modules = this.modules || []
				const modalities = this.modalities || []

				this.localModules = _.sortBy(modules, ['name']).map(module => {
					return {
						...module,
						identifier: 'module',
						key: 'modules',
						expanded: module.expanded ?? false,
						children: _.sortBy(
							modalities.filter(
								modality => modality.module_id === module.id
							),
							['name']
						).map(modality => {
							return {
								...modality,
								identifier: 'modality',
								key: 'modalities',
							}
						}),
					}
				})
			},
			OpenConfigModal(type, item) {
				this.selected = { type, item }
				this.showConfigModal = true
			},
		},
	}
</script>

<style lang="scss" scoped>
	#guides-container {
		padding: 1rem;
	}
</style>
